import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  list: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "list",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getCharRequestList.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getCharRequestList.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      list: payload?.data,
      totalCount: payload?.totalcount,
    }));
    builder.addCase(Act.getCharRequestList.rejected, (state, action) => ({
      ...state,
      loading: false,
      list: [],
      totalCount: 0,
    }));
    builder.addCase(Act.editCharRequest.pending, (state, action) => ({
        ...state,
        loading: false,
      }));
      builder.addCase(Act.editCharRequest.fulfilled, (state, { payload }) => ({
        ...state,
        loading: false,
      }));
      builder.addCase(Act.editCharRequest.rejected, (state, action) => ({
        ...state,
        loading: false,
      }));
  },
});

export default slice;
